/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\AttribuedCar\AttribuedCarTab\AttribuedCarTab.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 16th 2024 10:04:08 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useState } from "react";
import AttribuedCarService from "Services/AttribuedCar/AttribuedCarService";
import { AttribuedCarType } from "Type/AttribuedCar.type";
import AttribuedCarRow from "../AttribuedCarRow/AttribuedCarRow";
import { TablePaper } from "Content/Table/TablePaper";
import { Button } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";

type AttribuedCarTabProps = {
    offerID: string,
    setterCarcount: (nbCar: number, isDelete?: boolean) => void,
    setterFileCount: (nbFile: number, isDelete?: boolean) => void
};

export default function AttribuedCarTab(props: AttribuedCarTabProps) {
    const [attribuedCar, setAttribuedCar] = useState<AttribuedCarType[]>([]);
    const offerKeysOffer = ["File", "RegNb", "VIN", "OrderNb", "MEC", "DateDelivery", "DateReport", "DateEndContract", "EndMileage", "Action"];

    useEffect(() => {
        AttribuedCarService.getAttribuedCar(props.offerID).then((result) => {
            if (result.data)
                setAttribuedCar(result.data);
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    const handleCreateCar = () => {
        AttribuedCarService.createAttribuedCar(props.offerID).then((result) => {
            console.log("AttribuedCarService.createAttribuedCar")
            setAttribuedCar([
                ...attribuedCar,
                {...result.data, _count: { OfferFile: 0 }}
            ]);
            props.setterCarcount(1);
        }).catch((error) => {
            console.error(error);
        });
    };

    const handleDeleteCar = (attribuedCarID: string) => {
        AttribuedCarService.delete(attribuedCarID).then((result) => {
            const tmp = attribuedCar.filter(x => x.id !== result.data.deletedID);
            setAttribuedCar([...tmp]);
            props.setterCarcount(1, true);
        }).catch((error) => {
            console.error(error);
        });
    };

    const offerValues = useMemo(() => {
        return attribuedCar.map(x => <AttribuedCarRow key={Math.random()} data={x} handleDelete={handleDeleteCar} setterFileCountGlobal={props.setterFileCount} />);
    }, [attribuedCar]);

    return (
        <>
            <Button onClick={handleCreateCar}>{translator.decode("dynamic.newCarTemplate")}</Button>
            <TablePaper items={offerValues} headerList={offerKeysOffer} isCollapsable />
        </>
    )
};
